package com.milta.core.localization.translations.es

import com.milta.core.localization.AdminPromptsStrings

internal val AdminPrompts = AdminPromptsStrings(
    loading = "Cargando…",
    errorNoConnection = "No se puede contactar con el servidor — comprueba tu conexión.",
    errorGeneric = "Se produjo un error. Inténtalo de nuevo más tarde.",
    contractLockedNotice = "🔒 El contrato de salida (formato JSON) permanece bloqueado — se añade automáticamente en el servidor después del texto editado, para que la extracción en producción nunca se rompa.",
    notModifiedLabel = "Valor predeterminado — nunca modificado",
    modifiedOnPrefix = "Modificado el",
    resetToDefaultAction = "↺ Restablecer a los valores predeterminados",
    editableBodyLabel = "✏️ Contenido editable — reglas de negocio",
    markdownBoldSnippet = "**texto en negrita**",
    markdownItalicSnippet = "*texto en cursiva*",
    markdownCodeSnippet = "`código`",
    markdownHeadingSnippet = "## Título",
    markdownBulletSnippet = "- elemento de lista",
    markdownNumberedSnippet = "1. elemento de lista",
    markdownQuoteSnippet = "> cita",
    previewToggleEdit = "✏️ Editar",
    previewToggleShow = "👁 Vista previa",
    contractFooterLabel = "🔒 Contrato de salida — bloqueado, añadido automáticamente",
    actionErrorOffline = "Error — comprueba tu conexión.",
    actionErrorGeneric = "Error al guardar, inténtalo de nuevo.",
    unsavedChangesNotice = "● Cambios sin guardar",
    savingAction = "Guardando…",
    saveAction = "Guardar cambios",
)
